export default {
	title: "Orixás",
	name: "Nom",
	color: "Couleur",
	create: "Nouvel Orixá",
	edit: "Modifier l'Orixá",
	confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer l'orixá {name} ? Les personnes liées auront le champ vidé.",
	searchPlaceholder: "Rechercher un orixá...",
	noData: "Aucun orixá enregistré",
	stats: {
		total: "Total",
	},
	messages: {
		createSuccess: "Orixá créé avec succès",
		updateSuccess: "Orixá mis à jour avec succès",
		deleteSuccess: "Orixá supprimé avec succès",
		createError: "Erreur lors de la création de l'orixá",
		updateError: "Erreur lors de la mise à jour de l'orixá",
		deleteError: "Erreur lors de la suppression de l'orixá",
		loadError: "Erreur lors du chargement des orixás",
	},
	validation: {
		nameRequired: "Le nom est obligatoire",
		nameMaxLength: "Le nom doit comporter au maximum 100 caractères",
	},
};
